export default __webpack_public_path__ + "static/pr-leaves-e8aa502c0c050ba0a018e6179a24a568.png";